import React from 'react';
import { imgSet } from '../../mock';

const STEPS = [
  {
    n: '01',
    title: 'Meet your team',
    body: "You're welcomed by the same people who will look after you, at an easy, unhurried pace."
  },
  {
    n: '02',
    title: 'Talk about your needs',
    body: 'We start with a conversation — about your dental health, your history, and what matters to you.'
  },
  {
    n: '03',
    title: 'Make a plan',
    body: 'We explain what we see, answer your questions, and shape a plan together that makes sense for you.'
  },
  {
    n: '04',
    title: 'Feel confident in your care',
    body: 'You leave knowing exactly what comes next, with care that is comfortable, clear and considered.'
  }
];

export default function WhatToExpect() {
  return (
    <section className="relative bg-[#FAF7F2] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left: header + image */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6 reveal">
              <span className="h-px w-10 bg-[#8B7355]" />
              <span className="text-[10px] tracking-[0.32em] uppercase text-[#8B7355]">What to expect</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0B0B0B] leading-[1.05] reveal">
              A different kind of <span className="italic text-[#B69463]">dental visit</span>.
            </h2>
            <p className="mt-6 text-[#0B0B0B]/70 text-base md:text-lg leading-relaxed max-w-md reveal">
              New patients often tell us the visit felt easier than expected. Here's how it usually goes.
            </p>

            <div className="mt-10 image-zoom overflow-hidden aspect-[4/5] reveal">
              <img
                {...imgSet('clinic-waiting')}
                sizes="(max-width: 1024px) 100vw, 40vw"
                alt="Beechwood Dental Studio waiting room"
                width={1200}
                height={781}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right: steps */}
          <div className="lg:col-span-6 lg:pl-6 lg:pt-[280px]">
            <ul>
              {STEPS.map((step, i) => (
                <li
                  key={step.n}
                  className={`grid grid-cols-[80px_1fr] gap-6 py-8 md:py-10 reveal ${i !== 0 ? 'border-t border-[#0B0B0B]/15' : ''}`}
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="num-badge text-3xl md:text-4xl pt-1">{step.n}</div>
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl text-[#0B0B0B] leading-tight">{step.title}</h3>
                    <p className="mt-3 text-[#0B0B0B]/70 leading-relaxed max-w-md">{step.body}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
